export default class PlanoIKAcesso {
	constructor() {
		this.id = null;
		this.equipamentos = null;
		this.usuarios = null;
		this.operadores = null;
		this.valorMensalAcesso = null; // Valor Acesso
		this.valorMensalAcessoRef = null; // Valor Acesso + Controle de Refeição
		this.valorMensalAcessoEscola = null;// Valor Acesso + Escola
		this.valorMensalAcessoRefEscola = null; // Valor Acesso + Controle de Refeição + Escola		
		this.valorEquipamentoAdicional = null;
		this.valorUsuarioAdicional = null;
		this.valorOperadorAdicional = null;
		this.dataCadastro = null;
		this.dataInicio = null;
		this.dataFinal = null;
		this.dataPublicacao = null;
		this.publicado = false;
	}
}
